import { EditIcon } from '../../../../assets/icons/EditIcon';

const WalletCard = ({ wallet, onEdit, isEditable }) => {
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    return (
        <div className="border rounded-3xl p-5 relative bg-eerie-black border-zinc-700">
            
            <div className="flex justify-between items-start">
                <div className="flex items-center">
                    <div className="h-16 w-16 mr-3 rounded-full bg-charleston-green overflow-hidden flex items-center justify-center">
                        <img 
                            src={wallet.logo} 
                            alt={wallet.name}
                            className="h-14 w-14 rounded-full object-cover"
                        />
                    </div>
                    <div>
                        <h2 className="text-lg font-medium text-white">{wallet.name}</h2>
                    </div>
                </div>
                {isEditable && (
                    <button 
                        onClick={() => onEdit(wallet)}
                        className="p-3 text-zinc-500 hover:text-white border border-zinc-700 rounded-full transition-colors"
                    >
                        <EditIcon width={16} height={16} />
                    </button>
                )}
            </div>
            
            <div className="mt-6 space-y-1">
                <p className="text-xs text-zinc-500 uppercase">Balance</p>
                <p className="text-2xl font-bold text-white">{formatCurrency(wallet.balance)}</p>
            </div>
        </div>
    );
};

export default WalletCard;